<script>
import { chartHelpers } from "./Charts";
import { Bar } from 'vue-chartjs'

export default {
  extends: Bar,
  data () {
    return {
      cData: this.data
    }
  },
  props: {
    mergeColors: {
      type: Boolean,
      default: true
    },
    data: {
      type: Object,
      default() { 
        return {
          labels: ['March', 'April', 'May', 'June', 'July', 'August'],
          datasets: [
            {
              label: 'Page Views',
              fill: false,
              pointRadius: 5,
              data: [40, 39, 22, 20, 39, 30]
            },{
              label: 'Unique Hits',
              fill: false,
              pointRadius: 5,
              data: [34, 24, 36, 18, 34, 35]
            },{
              label: 'Abandoned',
              fill: false,
              pointRadius: 5,
              data: [30, 18, 7, 7, 19, 12]
            }
          ]
        }
      }
    },
    options: {
      type: Object,
      default() {
        return {
          responsive: true,
          maintainAspectRatio: false,
          legend:{display:false},
          scales: {
            yAxs: [{
                display: true,
                ticks: {
                  beginAtZero: false,
                  stepValue: 10
                }
            }]
          }
        };
      }
    }
  },
  computed: {
    mergedData: function () {
      if (this.mergeColors) {
        return chartHelpers.mergeColorsIntoData(this.cData);
      } else {
        return this.cData;
      }
    }
  },
  mounted () {
    this.renderChart(this.mergedData, this.options);
  },
  watch: {
    'cData.datasets': {
      handler: () => {
        this.renderChart(this.mergedData, this.options);
      }
    },
    deep: true
  }
};
</script>
